import React, { Component } from 'react';
import Blockies from 'react-blockies';
import jwtDecode from 'jwt-decode';
import { Icon, Drawer, message, Collapse, Tooltip } from 'antd';
import LoadingModal from '../modals/LoadingModal';
import Modal from 'react-modal';
import CountUp from 'react-countup'
import { updateAllowance as updateContractAllowance } from '../../contract/Token'
import { Provider, inject, observer } from "mobx-react"
import { getMvuBalance } from '../../contract/Token'
import moment from 'moment'
import { contractAddress } from "../../constants";
import { withdraw as withdrawFromContract } from "../../contract/Mevu"
import { CopyToClipboard } from 'react-copy-to-clipboard';
import TermsConditionsModal from '../modals/TermsConditionsModal'
import HelpModal from '../modals/HelpModal';
import { FaEthereum } from 'react-icons/fa';
import {mvuMultiplier} from '../../constants'

const oraclesControllerAddress = contractAddress.oraclesController;


Modal.setAppElement('#root')

@observer(["web3Store", "UserStore", "AdminStore", "contractStore"])
class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      user: null,
      username: '',
      showETHAddress: false,
      drawerVisible: false,
      modalIsOpen: false,
      previousBalance: 0,
      previousMvuBalance: 0,
      previousUnlockedEthBalance: 0,
      mvuBalance: 0,
    };

    this.handleShowETHAddress = this.handleShowETHAddress.bind(this);
    this.showDrawer = this.showDrawer.bind(this);
    this.onCloseDrawer = this.onCloseDrawer.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onAllowanceChange = this.onAllowanceChange.bind(this);
    this.updateAllowance = this.updateAllowance.bind(this);
    this.withdrawContractBalance = this.withdrawContractBalance.bind(this);
  }

  async componentWillMount() {
    const { auth: { accessToken } } = this.props;
    // console.log("access token " + accessToken);
    //console.log("jwt token " + JSON.stringify(jwtDecode(accessToken)));
    const { AdminStore, UserStore } = this.props;
    const { payload: { id } } = jwtDecode(accessToken);
    let self = this;
    AdminStore.getMvuAllowance();
    AdminStore.getContractEthBalance();
    getMvuBalance().then((balance) => {
      self.setState({ mvuBalance: balance })

    });

    fetch((process.env.REACT_APP_BACKEND_URL + '/users/' + id), {  //`${url}/users/${id}`
      headers: {
        Authorization: `Bearer ${accessToken}`

      }
    })
      .then(response => response.json())
      .then(user => {
        this.props.UserStore.setUser(user); this.setState({ user })
      })
      .catch(console.log);//window.alert);

  }

  randomUserName() {
    var nouns = require('../../assets/randomWords/nouns.json');
    var adjectives = require('../../assets/randomWords/adjectives.json');

    var noun = nouns[Math.floor(Math.random() * nouns.length)];
    var adjective = adjectives[Math.floor(Math.random() * adjectives.length)];

    var result = noun + adjective;

    return result
  }

  componentDidMount() {
    const { auth: { accessToken } } = this.props;
    let username = this.randomUserName();
    setTimeout(
      function () {
        if (this.props.UserStore.user.username === "") {
          console.log("NO USERNAME CHOSEN");
          fetch((process.env.REACT_APP_BACKEND_URL + '/users/' + this.state.user._id), {   //`${url}/users/${user._id}`
            body: JSON.stringify({ username }),
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'Content-Type': 'application/json',
            },
            method: 'PATCH'
          })
            .then(response => response.json())
            .then(user => setTimeout(
              function () {
                this.props.UserStore.setUser(user);
                this.setState({
                  user
                });
              }.bind(this),
              400
            ))
            .catch(err => {
              // window.alert(err);
              console.log(err);
            });
        }
      }.bind(this),
      500
    )
  }

  handleChange = ({ target: { value } }) => {
    this.setState({ username: value });
  };

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  handleSubmit = ({ target }) => {
    const success = () => {
      message.success('Username changed successfully!', 2);
    };
    const { auth: { accessToken } } = this.props;
    const { user, username } = this.state;
    this.setState({ modalIsOpen: true });
    console.log(JSON.stringify(user));

    fetch((process.env.REACT_APP_BACKEND_URL + '/users/' + user._id), {   //`${url}/users/${user._id}`
      body: JSON.stringify({ username }),
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',

      },
      method: 'PATCH'
    })
      .then(response => response.json())
      .then(user => setTimeout(
        function () {
          this.props.UserStore.setUser(user);
          this.setState({
            modalIsOpen: false,
            user
          });
        }.bind(this),
        400
      ))
      .then(
        setTimeout(
          success,
          400
        ))
      .catch(err => {
        //window.alert(err);
        console.log(err);
        setTimeout(
          function () {
            this.setState({
              modalIsOpen: false
            });
          }.bind(this),
          400
        );
      });
  };

  handleShowETHAddress() {
    this.setState({ showETHAddress: !this.state.showETHAddress })
  }

  showDrawer = () => {
    this.setState({
      drawerVisible: true,
    });
  };

  onCloseDrawer = () => {
    this.setState({
      drawerVisible: false,
    });
  };

  onAllowanceChange(event) {
    this.setState({ newAllowance: event.target.value });
  }

  updateAllowance() {
    const { contractStore, AdminStore } = this.props;
    let contracts = contractStore.contracts;
    if (!isNaN(this.state.newAllowance)) {
      console.log("updating");
      updateContractAllowance(oraclesControllerAddress, this.state.newAllowance * mvuMultiplier).then(function (result) {
        if (String(result).includes('User denied transaction signature')) {
          message.warning("Metamask transaction denied! Allowance not updated.");
        } else {
          AdminStore.getMvuAllowance();
        }
      });
    } else {
      message.info("New allowance must be a number!");
    }

  }

  withdrawContractBalance() {
    let self = this;
    let amountToWithdraw = this.props.AdminStore.unlockedEthBalance;
    console.log("withdrawing: " + amountToWithdraw);
    withdrawFromContract(amountToWithdraw).then(function (result) {
      if (String(result).includes('User denied transaction signature')) {
        message.warning("Metamask transaction denied! Will not withdraw.");
      } else {
        self.props.AdminStore.getContractEthBalance();
      }
    });
  }

  roundNum(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
  }

  render() {
    const Panel = Collapse.Panel;
    const customPanelStyle = {
      background: 'none',
      borderRadius: 0,
      marginBottom: 1,
      border: 0,
      overflow: 'hidden',
    };

    const { auth: { accessToken }, onLoggedOut } = this.props;
    const { payload: { publicAddress } } = jwtDecode(accessToken);
    const { loading, user } = this.state;
    const { AdminStore } = this.props;

    //if (user) console.log("user role " + user.role);

    let oracleStatus = "Not Verified";
    (loading ? null : AdminStore.oracleStatus ? oracleStatus = "Verified" : oracleStatus = "Not Verified");
    let mvuAllowance = (AdminStore.mvuAllowance ? AdminStore.mvuAllowance : 0);

    const username = user && user.username;
    let ethAddress = publicAddress;
    const ethMultiplier = 1000000000000000000;

    let addMvuAllowance = <div>
      Current MVU Allowance:  <span style={{ color: '#1874cb' }}>{mvuAllowance}</span>
      <br />
      <br />
      <div style={{ display: 'flex', marginBottom: '8px' }}>
        <input className="custom-input" onChange={this.onAllowanceChange} placeholder="0.00000 mvu" /><button className="custom-btn-primary" onClick={this.updateAllowance}>Update Allowance</button>
      </div>
      <span>The value entered here will <bold>REPLACE</bold> any remaining allowance amount.</span>
    </div>

    let changeUserName = <div style={{ display: 'flex' }}>
      <input className="custom-input" placeholder="Enter new username" name="username" onChange={this.handleChange} />
      <button className="custom-btn-primary" disabled={loading} onClick={this.handleSubmit}>Submit</button>
    </div>
    let userBalance;
    let userBalance1 = this.roundNum(this.props.web3Store.balanceEth.balance, 3);
    if (userBalance1 != this.state.previousBalance) {
      userBalance = <CountUp duration={1.75}
        separator=" "
        decimals={4}
        decimal="."
        suffix=" ETH"
        onEnd={() => this.setState({ previousBalance: userBalance1 })}
        onStart={() => console.log('Started! 💨')}
        start={this.state.previousBalance}
        end={userBalance1} />


    } else {
      userBalance = userBalance1 + " ETH";
    }

    let mvuBalance;
    let mvuBalance1 = this.roundNum(this.state.mvuBalance, 3) / mvuMultiplier;
    if (mvuBalance1 != this.state.previousMvuBalance) {
      mvuBalance = <CountUp duration={1.75}
        separator=" "
        decimals={4}
        decimal="."
        suffix=" MVU"
        onEnd={() => this.setState({ previousMvuBalance: mvuBalance1 })}
        onStart={() => console.log('Started! 💨')}
        start={this.state.previousMvuBalance}
        end={mvuBalance1} />


    } else {
      mvuBalance = mvuBalance1 + " MVU";
    }

    let unlockedEthBalance;
    let unlockedEthBalance1 = this.roundNum(this.props.AdminStore.unlockedEthBalance, 3) / ethMultiplier;
    if (unlockedEthBalance1 != this.state.previousUnlockedEthBalance) {
      unlockedEthBalance = <CountUp duration={1.75}
        separator=" "
        decimals={4}
        decimal="."
        suffix=" ETH"
        onEnd={() => this.setState({ previousUnlockedEthBalance: unlockedEthBalance1 })}
        onStart={() => console.log('Started! 💨')}
        start={this.state.previousUnlockedEthBalance}
        end={Math.round(unlockedEthBalance1 * 1000) / 1000} />


    } else {

      unlockedEthBalance = Math.round(unlockedEthBalance1 * 1000) / 1000 + " ETH";

    }




    return (
      <div className="header-profile">
        <div className="header-profile-info">

          {/* <div className="header-profile-balance-contracts">
            <div className="header-profile-balance-title">CONTRACTS BALANCE</div>
            <div className="header-profile-balance-contracts-flex">
              <div className="header-profile-balance-value" style={{ margin: '3px 9px 0px 0px' }}>{unlockedEthBalance}</div>
              <div className="header-profile-info-withdrawl-btn"><button onClick={this.withdrawContractBalance} className="custom-btn-success">WITHDRAW</button></div>
            </div>

          </div> */}

          {/* <div className="header-profile-balance-metamask">
            <div className="header-profile-balance-title">METAMASK BALANCE</div>
            <div className="header-profile-balance-metamask-flex">
              <div className="header-profile-balance-value">{userBalance}</div>
              <div className="header-profile-balance-value">{mvuBalance}</div>
            </div>
          </div> */}

          <div className="header-profile-info-username-wrap">
            <div className="header-profile-info-username-radius" style={{ cursor: "pointer" }} onClick={this.showDrawer}>
              <Blockies seed={publicAddress} />
              <div className="header-profile-info-username">{username}</div>
            </div>
          </div>
          {/* <div className="header-profile-buttons" style={{ padding: '19px 8px 0px 0px' }}>
            <button className="custom-btn-primary" data-toggle="tooltip" data-placement="left" title="settings" onClick={this.showDrawer}>
              <Icon type="setting" />
            </button>
          </div> */}
          <div className="header-profile-buttons">
            <HelpModal />
          </div>
        </div>
        <Drawer
          title="USER INFO AND SETTINGS"
          placement="right"
          closable={true}
          onClose={this.onCloseDrawer}
          visible={this.state.drawerVisible}
        >

          <div style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.08)', padding: '0px 0px 5px 5px' }}>
            <div style={{ padding: '0px 0px 0px 6px', marginBottom: '0px' }}>
              {/* <img style={{ margin: '0px 7px 0px 0px' }} src={require('../../assets/img/metamask-logo.png')} width="18" />  */}
              MetaMask Account Balances</div>
            {/* <div className="eth-address" style={{ cursor: 'pointer' }}>
              <CopyToClipboard text={ethAddress}>
                <Tooltip placement="bottom" title="Click to copy">
                  {ethAddress}
                </Tooltip>
              </CopyToClipboard>
            </div> */}
            <div className="eth-address" style={{ display: 'inline-block' }}>
              <FaEthereum style={{ fontSize: '16px', color: '#27f727' }} /> <span>{userBalance}</span>
            </div>
            <br />
            <div className="eth-address" style={{ display: 'inline-block' }}>
              <img style={{ margin: '0px 7px 0px 0px' }} src={require('../../assets/img/logoV.svg')} width="15" /> <span>{mvuBalance}</span>
            </div>

          </div>
          <div style={{ padding: '5px 0px 5px 5px', borderBottom: '1px solid rgba(255, 255, 255, 0.08)' }}>
            <div style={{ padding: '0px 0px 0px 6px', marginBottom: '0px', display: 'inline-block' }}>Contracts Account Balance</div>
            <br />
            <div className="eth-address" style={{ display: 'inline-block' }}>
              <FaEthereum style={{ fontSize: '16px', color: '#27f727' }} /> <span>{unlockedEthBalance}</span>
              <br />
              <br />
              <div className="header-profile-info-withdrawl-btn"><button onClick={this.withdrawContractBalance} className="custom-btn-success">WITHDRAW</button></div>

            </div>

          </div>

          {/* <div style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.08)', padding: '5px 0px 5px 5px' }}>
            <div style={{ padding: '0px 0px 0px 6px', marginBottom: '0px', display: 'inline-block' }}><img style={{ margin: '0px 7px 0px 0px' }} src={require('../../assets/img/logoV.svg')} width="15" /> Mevu User ID: </div>
            <div className="eth-address" style={{ display: 'inline-block', cursor: 'pointer' }}>
              <CopyToClipboard text={this.props.UserStore.user._id}>
                <Tooltip placement="bottom" title="Click to copy">
                  {this.props.UserStore.user._id}
                </Tooltip>
              </CopyToClipboard>
            </div>
          </div> */}
          <div style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.08)', padding: '5px 0px 5px 5px' }}>
            <div style={{ padding: '0px 0px 0px 6px', marginBottom: '0px', display: 'inline-block' }}><Icon type="safety" style={{ fontSize: '16px', color: '#08c' }} theme="outlined" /> Oracle Status: </div>
            <div className="eth-address" style={{ display: 'inline-block' }}>
              <span style={AdminStore.oracleStatus ? { color: '#3ac55a' } : { color: '#f53c40' }}>{oracleStatus.toUpperCase()}</span>
            </div>
          </div>
          <div style={{ padding: '5px 0px 5px 5px' }}>
            <div style={{ padding: '0px 0px 0px 6px', marginBottom: '0px', display: 'inline-block' }}><Icon type="clock-circle" style={{ fontSize: '16px', color: '#f53c40' }} theme="outlined" /> Oracle Period: </div>
            <div className="eth-address" style={{ display: 'inline-block' }}>
              <span>{moment.duration(Number(AdminStore.oraclePeriod), 'seconds').humanize().toUpperCase()}</span>
            </div>
          </div>
          <Collapse bordered={false} defaultActiveKey={['0']}>
            <Panel header="Change Username" key="1" style={customPanelStyle}>
              <div>Current Username: <span style={{ color: '#1874cb' }}>{username}</span></div><br />
              {changeUserName}
            </Panel>
            <Panel header="Change Mvu Allowance" key="2" style={customPanelStyle}>
              {addMvuAllowance}
            </Panel>
            {/*<Panel header="Setting 3" key="3" style={customPanelStyle}>
              <p>text</p>
            </Panel>*/}

            <div style={{ textAlign: 'center', padding: '25px 0px' }} ><TermsConditionsModal /></div>

          </Collapse>
       


        </Drawer>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Loading Modal"
          className="login-modal"
          overlayClassName="login-modal-overlay"
        >
          <div className="modal-close-btn" onClick={this.closeModal}><Icon type="close-circle" /></div>
          <h2 style={{ textAlign: 'center', fontWeight: '100', textTransform: 'uppercase' }}>Changing your username...</h2>
          <LoadingModal />
        </Modal>
      </div >
    );
  }
}

export default Profile;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/Profile.js